import React, { useEffect, useState } from "react";
import { Search, Download, Mail, MessageSquare } from "lucide-react";
import { api, money, API } from "@/lib/api";

export default function AdminCustomers() {
  const [customers, setCustomers] = useState([]);
  const [q, setQ] = useState("");
  const [consent, setConsent] = useState("");

  const load = () => {
    const params = new URLSearchParams();
    if (q) params.set("q", q);
    if (consent) params.set("consent", consent);
    api.get(`/admin/customers?${params}`).then((r) => setCustomers(r.data)).catch(() => {});
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [consent]);

  const exportCsv = () => { window.open(`${API}/admin/customers/export`, "_blank"); };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="font-display text-3xl uppercase text-white">Customers</h1>
        <button data-testid="export-customers" onClick={exportCsv} className="rounded-md border border-[#27272A] px-4 py-2.5 text-sm text-white hover:border-[#D4AF37] flex items-center gap-1.5"><Download size={15} /> EXPORT CSV</button>
      </div>

      <div className="flex flex-wrap gap-2 mb-4">
        <div className="relative flex-1 min-w-[200px]">
          <Search size={16} className="absolute left-3 top-3 text-zinc-500" />
          <input data-testid="customer-search" placeholder="Search name, email, phone…" value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()} className="w-full rounded-md bg-[#141417] border border-[#27272A] pl-9 pr-4 py-2.5 text-white text-sm outline-none focus:border-[#D4AF37]" />
        </div>
        {[["", "All"], ["email", "Email Opt-in"], ["sms", "SMS Opt-in"]].map(([v, l]) => (
          <button key={v} data-testid={`consent-filter-${v || "all"}`} onClick={() => setConsent(v)} className={`rounded-md px-3 py-2.5 text-xs font-oswald tracking-widest ${consent === v ? "bg-[#D4AF37] text-black" : "border border-[#27272A] text-zinc-300"}`}>{l}</button>
        ))}
      </div>

      <div className="rounded-xl border border-[#27272A] overflow-x-auto">
        <table className="w-full text-sm min-w-[640px]">
          <thead className="bg-[#18181B] text-zinc-400"><tr>
            <th className="text-left px-4 py-3 font-medium">Name</th>
            <th className="text-left px-4 py-3 font-medium">Email</th>
            <th className="text-left px-4 py-3 font-medium">Phone</th>
            <th className="text-center px-4 py-3 font-medium">Orders</th>
            <th className="text-right px-4 py-3 font-medium">Spend</th>
            <th className="text-center px-4 py-3 font-medium">Consent</th>
          </tr></thead>
          <tbody>
            {customers.map((c) => (
              <tr key={c.id} data-testid={`customer-row-${c.id}`} className="border-t border-[#27272A] text-zinc-200">
                <td className="px-4 py-3">{c.first_name} {c.last_name}</td>
                <td className="px-4 py-3 text-zinc-400">{c.email || "—"}</td>
                <td className="px-4 py-3 text-zinc-400">{c.phone || "—"}</td>
                <td className="px-4 py-3 text-center">{c.total_orders}</td>
                <td className="px-4 py-3 text-right text-[#D4AF37]">{money(c.total_spend)}</td>
                <td className="px-4 py-3 text-center">
                  <div className="flex justify-center gap-1.5">
                    {c.marketing_email_consent && <Mail size={14} className="text-emerald-400" />}
                    {c.marketing_sms_consent && <MessageSquare size={14} className="text-emerald-400" />}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {customers.length === 0 && <div className="p-10 text-center text-zinc-500">No customers found.</div>}
      </div>
    </div>
  );
}
